import { render, staticRenderFns } from "./GastroAnamnesiFisiologicaEditComponent.vue?vue&type=template&id=a8c5f142"
import script from "./GastroAnamnesiFisiologicaEditComponent.vue?vue&type=script&lang=js"
export * from "./GastroAnamnesiFisiologicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports